/*
 * @Date: 2022-09-26 11:03:02
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-19 15:06:08
 * @description: description
 */
export default {
  banner: {
    title: '关于我们',
    titleEn: 'About Us',
    link: '',
    content: [
      '极客邦科技，以 “推动数字人才全面发展，助力数字中国早日实现” 为⼰任，致⼒于为技术从业者提供全⾯的、⾼质量的资讯、课程、会议、培训等服务。极客邦科技的核⼼是独特的专家⽹络和优质内容⽣产体系，为企业、个⼈提供其成功所必需的技能和思想。',
      '极客邦科技⾃ 2007 年开展业务⾄今，已建设线上全球软件开发知识与创新社区 InfoQ，发起并成⽴技术领导者社区 TGO 鲲鹏会，连续多年举办业界知名技术峰会（如 QCon、ArchSummit 等），⾃主研发数字⼈才在线学习产品极客时间 App，以及企业级⼀站式数字技术学习 SaaS 平台，在技术⼈群、科技驱动型企业、数字化产业当中具有⼴泛的影响⼒。',
      '⼗余年间，公司业务遍布中国⼤陆主要城市、港澳台地区，以及美国硅⾕等，已经为数千万技术⼈，上万家企业提供服务。'
    ],
    cover: require('@/assets/img/aboutus/pc/banner/aboutus-banner.png')
    // coverMobile: require('../../assets/img/resource/master/master-lyh.png')
  },
  // 核心价值观
  senseOfWorth: {
    title: '核心价值观',
    content: [
      {
        label: '诚实做人',
        cover: require('@/assets/img/aboutus/pc/sense.of.worth/cszr.png'),
        coverMobile: require('@/assets/img/aboutus/mobile/sense.of.worth/cszr.png'),
        info: '要做事，先做人。胸怀坦荡，有情有义，阳光而自信，专业而靠谱，这些是极客邦人身上深深的烙印。'
      },
      {
        label: '踏实做事',
        cover: require('@/assets/img/aboutus/pc/sense.of.worth/tszs.png'),
        coverMobile: require('@/assets/img/aboutus/mobile/sense.of.worth/tszs.png'),
        info: '满怀热情，踏踏实实，服务到客户满意为止，这是极客邦成立那一天起，就给到客户的承诺，承诺有效期: 永远。'
      },
      {
        label: '勇猛精进',
        cover: require('@/assets/img/aboutus/pc/sense.of.worth/ymjj.png'),
        coverMobile: require('@/assets/img/aboutus/mobile/sense.of.worth/ymjj.png'),
        info: '以无所不学的态度面对不确定性和快速变化的环境，锐意进取，每天前进三十公里，打下一个又一个胜仗。'
      },
      {
        label: '成就客户',
        cover: require('@/assets/img/aboutus/pc/sense.of.worth/cjkh.png'),
        coverMobile: require('@/assets/img/aboutus/mobile/sense.of.worth/cjkh.png'),
        info: '帮助客户成功，和客户一起成功是极客邦公司存在的根本原因，这要求我们必须扎根于客户并用专业的产品和服务为客户持续创造价值。'
      }
    ],
    contentMobile: [
      [
        {
          label: '诚实做人',
          info: '要做事，先做人。胸怀坦荡，有情有义，阳光而自信，专业而靠谱，这些是极客邦人身上深深的烙印。'
        },
        {
          label: '踏实做事',
          info: '满怀热情，踏踏实实，服务到客户满意为止，这是极客邦成立那一天起，就给到客户的承诺，承诺有效期: 永远。'
        }
      ],
      [
        {
          label: '勇猛精进',
          info: '以无所不学的态度面对不确定性和快速变化的环境，锐意进取，每天前进三十公里，打下一个又一个胜仗。'
        },
        {
          label: '成就客户',
          info: '帮助客户成功，和客户一起成功是极客邦公司存在的根本原因，这要求我们必须扎根于客户并用专业的产品和服务为客户持续创造价值。'
        }
      ]
    ],
    culture: {
      title: '诚实做人',
      content: '要做事，先做人。胸怀坦荡，有情有义，阳光而自信，专业而靠谱，这些是极客邦人身上深深的烙印。',
      cover: require('@/assets/img/aboutus/pc/sense.of.worth/cjkh.png')
    }
  },
  // 发展历程
  developmentHistory: {
    title: '发展历程',
    cover: require('@/assets/img/aboutus/pc/development.history/bg-history.png'),
    coverMobile: require('@/assets/img/aboutus/mobile/development.history/bg-history.png')
  },
  // 荣誉
  honor: {
    title: '资质荣誉',
    authentication: [
      {
        content: 'ISO 27001信息安全管理体系标准认证',
        cover: require('@/assets/img/aboutus/pc/honor/honor-27001.png')
      },
      {
        content: 'ISO 9001信息安全管理体系标准认证',
        cover: require('@/assets/img/aboutus/pc/honor/honor-9001.png')
      },
      {
        content: '国家信息安全等级保护三级认证',
        cover: require('@/assets/img/aboutus/pc/honor/honor-three.png')
      }
    ],
    mobileContent: [
      {
        title: '权威机构背书',
        content: [
          '工信部人才交流中心“重点领域产业人才基地”单位',
          '中国移动通信联合会教育与考试中心人才培养基地',
          '中国移联《ICT行业讲师评价体系及评定标准的研究》立项证书',
          '《培训》杂志企业人才培训基地',
          '《培训》杂志“中国企业数字人才发展研究中心”'
        ]
      },
      {
        title: '教育培训领军企业',
        content: [
          '北京市高精尖产业技能提升在线培训平台',
          '中国互联网教育领军会核心委员单位',
          '2021优秀数字化人才赋能服务商博奥奖',
          '培训杂志新锐服务机构',
          '2021中国在线教育百强企业'
        ]
      },
      {
        title: '高科技企业',
        content: [
          '北京市专精特新“小巨人”企业',
          '北京民营企业中小百强',
          '国家高新技术企业',
          '中关村高新技术企业',
          '中关村瞪羚企业',
          '科技部科技型中小企业',
          '朝阳区高科技高成长二十强'
        ]
      },
      {
        title: '党建工作',
        content: [
          '北京市朝阳区东湖街道商会副会长单位',
          '北京市非公有制经济组织党建示范单位 '
        ]
      }
    ],
    background: {
      title: '权威机构背书',
      content: [
        '工信部人才交流中心“重点领域产业人才基地”单位',
        '中国移动通信联合会教育与考试中心人才培养基地',
        '中国移联《ICT行业讲师评价体系及评定标准的研究》立项证书',
        '《培训》杂志企业人才培训基地',
        '《培训》杂志“中国企业数字人才发展研究中心”'
      ]
    },
    leadingEnterprise: {
      title: '教育培训领军企业',
      contentLeft: [
        '北京市高精尖产业技能提升在线培训平台',
        '中国互联网教育领军会核心委员单位',
        '2021优秀数字化人才赋能服务商博奥奖'
      ],
      contentRight: [
        '培训杂志新锐服务机构',
        '2021中国在线教育百强企业'
      ]
    },
    science: {
      title: '高科技企业',
      contentLeft: [
        '北京市专精特新“小巨人”企业',
        '北京民营企业中小百强',
        '国家高新技术企业',
        '中关村高新技术企业'
      ],
      contentRight: [
        '中关村瞪羚企业',
        '科技部科技型中小企业',
        '朝阳区高科技高成长二十强'
      ]
    },
    partyBuilding: {
      title: '党建工作',
      content: [
        '北京市朝阳区东湖街道商会副会长单位',
        '北京市非公有制经济组织党建示范单位 '
      ]
    }
  },
  partner: {
    title: '我们的伙伴',
    tabs: [
      {
        id: 1,
        name: '成就客户',
        content: [
          {
            info: '“通过和极客时间的合作，极大补充了在人才培养过程中技术类培训的支持，能够让所有人员满足我们能力模型的要求。如果企业想做数字化转型的话，可以借助极客时间的力量，来帮助企业迅速打造数字化人才团队。”',
            inscribe: '西门子培训负责人'
          },
          {
            info: '“极客邦科技为我们提供从公司技术品牌提升到人才培养体系搭建的定制化一体式解决方案，在品牌方面，通过参与 QCon 大会技术演讲，打造技术品牌影响力。在人才培养方面，极客时间为我们提供了包括 GO & k8s、 架构师、产品经理、数据建模师等不同岗位的数字人才进行专项训练解决方案。通过一年半时间，落实内部技术人员数字化思维及技能提升的培训方针，形成了从行领导到行员对转型工作的高认可度和强共识性，极大程度地提升了数字化转型的效率。”',
            inscribe: '中原银行培训负责人'
          }
        ]
      },
      {
        id: 2,
        name: '成就用户',
        content: [
          {
            info: '“转眼间注册极客时间也已经两年半了，感谢极客时间能让我沉下心来学习，不断形成知识体系，在广度和深度上都有所突破…..我能体会到每一门课程都注重基础、注重积累，像艺术品一样精心雕琢，每一课都实实在在，慢即是快，这就像一种生活态度和方式，希望未来也能继续和极客时间相伴，不断精进。”',
            inscribe: '极客时间用户'
          },
          {
            info: '“面试了 100 多位候选人中，超过 50%的候选人都使用极客时间进行学习。我自己学了 10 多门课程，干货很多。极客时间这个产品可以促进技术领域知识和经验的传承和流动，进而提高整个业界的水平。期待与极客时间一起保持初心，继续前行。”',
            inscribe: '极客时间用户'
          }
        ]
      },
      {
        id: 3,
        name: '成就社区',
        content: [
          {
            info: '“无限生长”代表了无限种可能，也代表了无限的机会。InfoQ 这几年一直在关注数字化人才以及传统企业的数字化转型，这也是我们一直关注和倡导的。不断吸收技术人才，完成企业的创新和技术的创新，才能推动行业的发展，未来才有无限的可能。',
            inscribe: '中国信通院云大所所长何宝宏'
          },
          {
            info: '“我记得我在2015 年第一次加入到 Linux Foundation 的时候，就认识了 InfoQ。我觉得 InfoQ 更像你的朋友，而不仅仅是一个媒体社区，他们真的是很热心帮助开发人员提升自己，并且取得成功。',
            inscribe: 'Linux Foundation 亚太区总监 Keith Chan'
          }
        ]
      }
    ]
  }
}
